import kfetch from 'util/kfetch';
import urls from 'constants/urls/urls';
import { initializeGameData } from 'actions/init/actionCreators';
import analyticsUtil from 'util/segmentUtil';


export const fetchStoryline = () => (dispatch) => kfetch(urls.GAME_API)
	.then((response) => {
		 //Segment integartion
		 if(response && response.userDetails){
			const uliId = response.userDetails.uliId;
			const grpId = response.userDetails.groupId;
            analyticsUtil.identify(uliId,response.userDetails);
            analyticsUtil.group(grpId,response.userDetails);
        }
		dispatch(initializeGameData(response));
	});
